export default function () {
  window.onNuxtReady(() => {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = '/fonts.css'
      document.head.appendChild(link)
  })
}
